<template>
  <div class="scene-final-mobile" :class="classList">

    <MapObject class="scene-final-mobile__trees" src="/map/mobile_final_trees.png" :animated="ready" type="trees"></MapObject>
    <MapObject class="scene-final-mobile__b1" src="/map/build_6f.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-final-mobile__b2" src="/map/build_8f_1.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-final-mobile__b3" src="/map/build_8f_2.png" :animated="ready" type="building"></MapObject>
  </div>
</template>

<script>
  import Scene from './Scene.vue'

  export default {
    extends: Scene,
  }
</script>

<style lang="scss">
  .scene-final-mobile {
    @include relative-units(322.13px, 200.75px, mobile)
  }

  .scene-final-mobile__trees {
    left: -1%;
    top: -1%;
    width: 100%;
  }
  .scene-final-mobile__b1 {
    left: 62.8%;
    top: 45.1%;
    width: 14%;
  }
  .scene-final-mobile__b2 {
    left: 48%;
    top: 55.2%;
    width: 14%;
  }
  .scene-final-mobile__b3 {
    left: 36%;
    top: 66%;
    width: 14.1%
  }
</style>
